<div class="container">
    <div class="custom-div" *ngIf="inited" style.width="{{gridActualWidth}}">
        <div class="print-name h3-regular" *ngIf="isPrintView">
            {{name}}
        </div>
        <span class="body-2" *ngIf="showItemCount">{{displayDataLen}} items</span>
        <button class="hidden-btn excelexportBtn" type="button" (click)="exportAsXLS()">{{'general.export_excel' |
            stringLiterals}}</button>
        <ng-container *ngIf="showGridContextMenu">
            <div class="meatball" (click)="showContextMenu($event)">
                <smart-icon name="cog" class="light"></smart-icon>
            </div>
            <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
        </ng-container>
    </div>
    <div class="gridster-item-content" [ngClass]="gridSettingClass" #gridInst>
        <ng-container *ngIf="inited">
            <ag-grid-angular style="width: 100%;" [style.height]="bottomData.length===0 ? '100%' : 'calc(100% - 29px)'"
                #topGrid class="ag-theme-balham top-grid" [gridOptions]="gridOptions" [columnDefs]="columnDefs"
                [suppressHorizontalScroll]="bottomData.length!==0" [rowData]="data" [excelStyles]="excelStyles"
                [aggFuncs]="aggFuncs" [components]="frameworkComponents" [groupRowInnerRenderer]="groupRowInnerRenderer"
                [groupRowRendererParams]="groupRowRendererParams" (bodyScroll)="onBodyScroll($event)"
                (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)">
            </ag-grid-angular>
            <div *ngIf="bottomData.length!==0" style="position: relative; height: 29px;">
                <span class="bottom-total">Total</span>
                <ag-grid-angular style="width: 100%; height: 100%;" #bottomGrid class="ag-theme-balham bottom-grid"
                    [rowData]="bottomData" [gridOptions]="bottomOptions" headerHeight="0"
                    [columnDefs]="bottomColumnDefs" [aggFuncs]="aggFuncs" [components]="frameworkComponents"
                    [groupRowInnerRenderer]="groupRowInnerRenderer" [groupRowRendererParams]="groupRowRendererParams"
                    (gridReady)="onBottomGridReady($event)">
                </ag-grid-angular>
            </div>
        </ng-container>
    </div>
</div>